import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import FetchPlease from 'fetch-please'
import debounce from 'debounce'
import { SearchSelectBox } from 'containers'
import { getAutocompleteService } from 'apis/google-maps'
import { fetchGeoDataFromAddress } from 'apis/geo'

import { noop } from 'utils'
import { gtmEvent } from 'higher-order-components'
import Highlighter from 'react-highlight-words'
import googleAutoComplete from 'AtomicUtils/googleAutoComplete'

class DealerSearchBox extends PureComponent {
  constructor(props) {
    super(props)
    this.google = new googleAutoComplete()
    this.state = {
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: (props.value && props.value.toString()) || '',
      didEdit: false,
      inputValue: ''
    }

    this.dealerSearch = new FetchPlease(props.dealerSearchEndPoint, {
      timeout: 3000,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    this.debouncedLocationSearchToState = debounce(
      search => this.doLocationSearchToState(search),
      500
    )
  }

  // Api fns - consider reafactoring and moving these out of component.

  getAutocompleteService = async () => {
    if (this.autocompleteService && this.autocompleteOK !== undefined) {
      return this.autocompleteService
    }

    try {
      const { autocompleteService, statusCodes } = await getAutocompleteService()

      this.autocompleteService = autocompleteService
      this.autocompleteOK = statusCodes.OK

      return this.autocompleteService
    } catch (error) {
      console.warn(error)
      throw error
    }
  }

  searchOverride = (search) => {
    this.doLocationSearchToState(search).then((results = []) => {
      const item = results.find(result => result.label === search) || results[0]
      this.setState({ currentSearchValue: item ? String(item.value) : '' }, () => {
        this.handleSelectChange(item, true)
      })
    })
  }

  doDealerSearch = (search) => {
    this.dealerSearch && this.dealerSearch.abort()
    return this.dealerSearch.post('', { searchText: search }).then(({ data }) => data)
  }

  doPredictionSearch = search => this.getAutocompleteService()
    .then(service => new Promise((resolve, reject) => {
      service.getPlacePredictions(
        {
          input: search,
          componentRestrictions: this.props.componentRestrictions || null,
          types: ['(regions)']
        },
        (predictions, status) => {
          if (status !== this.autocompleteOK) reject(status)
          else {
            resolve(predictions.filter(({ types }) =>
              ['colloquial_area'].some(type => types.indexOf(type) === -1) &&
              ['postal_code', 'locality'].some(type => types.indexOf(type) !== -1)))
          }
        }
      )
    }))
    .catch(error => console.warn('Google response:', error))

  doLocationSearchToState = async (search) => {
    let { dealerSearch = [], autocompleteItems = [] } = this.state

    try {
      console.log('do search')
      console.log(search)
      const [dealerResults, autocompleteResults] = await Promise.all([
        this.doDealerSearch(search),
        this.doPredictionSearch(search)
      ])

      dealerSearch = dealerResults
      autocompleteItems = autocompleteResults
    } catch (error) {
      console.warn(error)
    }

    const searchOptions = this.createSearchOptions({
      dealerSearch,
      autocompleteItems
    })

    this.setState({
      dealerSearch,
      autocompleteItems,
      searchOptions
    })

    return searchOptions
  }

  doAutoSearchFromState = () => {
    if (!this.state.currentSearchValue) return

    this.doLocationSearchToState(this.state.currentSearchValue).then(([firstResult = {}] = []) =>
      this.setState({
        currentSearchValue: firstResult.value || ''
      }))
  }

  //

  componentWillMount() {
    const { searchOverride } = this.props
    if (searchOverride) {
      this.searchOverride(searchOverride)
    }
    this.doAutoSearchFromState()
  }

  componentWillReceiveProps({ value, searchOverride }) {
    if (!this.state.didEdit && value) {
      const value = value.toString()
      this.setState({ currentSearchValue: value }, () => {
        this.doAutoSearchFromState()
      })
    }
    if (searchOverride !== this.props.searchOverride) {
      this.searchOverride(searchOverride)
    }
  }

  clearAutocomplete = () => {
    this.setState({
      autocompleteItems: [],
      dealerSearch: [],
      searchOptions: [],
      currentSearchValue: ''
    })
  }

  handleInputChange = (value) => {
    this.setState({ didEdit: true, inputValue: value })

    if (!value) {
      return
    }

    this.debouncedLocationSearchToState(value)
  }

  handleSelectChange = (props, isOnLoad) => {
    this.setState({ didEdit: true })
    const { value } = props || {}

    if (!props || !value) {
      this.clearAutocomplete()
      return
    }

    let currentItem = this.getCurrentItem(value)
    console.log('dealer search box')
    console.log(JSON.stringify(currentItem))
    //var place = new{}
    if (currentItem && currentItem.place_id) {
      console.log(currentItem.description)
      console.log(this.google)


      // this.google.searchAddress(currentItem.description, (response) => {
      //   console.log('searchAddress')
      //   console.log(JSON.stringify(response))
      //   console.log(JSON.stringify(response[0].structured_formatting.secondary_text))

      //   this.google.getPostcode(response[0].structured_formatting.secondary_text, (response2) => {
      //     console.log('getPostcodeUsingLatLong')
      //     console.log(JSON.stringify(response2))
      //   });

      //   this.google.searchAddress(response[0].structured_formatting.secondary_text, (response3) => {
      //     console.log('searchAddress again')
      //     console.log(JSON.stringify(response3))
      //   })

        // this.google.getPostcode(response.structured_formatting.secondary_text, (response1) => {
        //   console.log('getPostcode')
        //   console.log(JSON.stringify(response1))
        //   //getPlaceUsingPlaceId
        //   if(response1 && response1.length > 0)
        //   {
        //     console.log('geometry')
        //     console.log(JSON.stringify(response1[0].geometry))
        //     var geometry = response1[0].geometry.location
        //     this.google.getPostcodeUsingLatLong(geometry.lat, geometry.lng, (response2) => {
        //       console.log('getPostcodeUsingLatLong')
        //       console.log(JSON.stringify(response2))
        //     });
        //   }

        // });

     // });



      fetchGeoDataFromAddress({
        placeId: currentItem.place_id
      }).then(({ addressDetails }) => {
        console.log(addressDetails)
        currentItem = addressDetails
        this.props.onChange(currentItem, isOnLoad)
      })

      this.props.onSelect(currentItem.description, currentItem.place_id)
    } else if (currentItem && currentItem.value) {
      currentItem = { ...currentItem, dealerCode: currentItem.value }
      this.props.onChange(currentItem, isOnLoad)
    } else {
      this.props.onChange(currentItem, isOnLoad)
    }
    // We don't want a GTM event to fire on first load, hence the checking.
    if (!isOnLoad && this.state.searchOptions[value]) {
      this.props.gtmEvent({
        gtmID: this.props.gtmMapping.ENTER_LOCATION,
        gtmPayload: {
          location: this.state.searchOptions[value].label
        }
      })
    }

    this.setState({ currentSearchValue: value })
  }

  createSearchOptions = ({ dealerSearch = [], autocompleteItems = [] }) => {
    if (dealerSearch) {
      const dealersCount = dealerSearch.length
      return dealerSearch
        .map(({ display }, index) => ({
          value: index.toString(),
          label: display
        }))
        .concat(autocompleteItems.map(({ description }, index) => ({
          value: (index + dealersCount).toString(),
          label: description
        })))
    }
    return []
  }

  getCurrentItem = (searchValue) => {
    const { dealerSearch = [], autocompleteItems = [] } = this.state
    return dealerSearch.concat(autocompleteItems)[parseInt(searchValue, 10)]
  }

  render() {
    const { placeholder } = this.props
    const { searchOptions, currentSearchValue } = this.state

    return (
      <div key={'DealerSearchBox'}>
        <SearchSelectBox
          placeholder={placeholder}
          onChange={value => this.handleSelectChange(value, false)}
          onInputChange={this.handleInputChange}
          onBlur={() => {
            this.setState({ inputValue: '' })
          }}
          optionRenderer={({ label }) => (
            <Highlighter
              highlightStyle={{ fontWeight: 400, backgroundColor: 'transparent' }}
              searchWords={this.state.inputValue.split(' ')}
              textToHighlight={label} />
          )}
          value={currentSearchValue}
          options={searchOptions} />
      </div>
    )
  }
}

DealerSearchBox.propTypes = {
  dealerSearchEndPoint: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  componentRestrictions: PropTypes.object,
  searchOverride: PropTypes.string,
  gtmMapping: PropTypes.object,
  gtmEvent: PropTypes.func
}

DealerSearchBox.defaultProps = {
  dealerSearchEndPoint: '',
  placeholder: 'Enter your postcode, suburb or Dealer name',
  value: '',
  onSelect: noop,
  onChange: noop,
  componentRestrictions: {},
  gtmMapping: {}
}

export default gtmEvent()(DealerSearchBox)



// WEBPACK FOOTER //
// ./src/components/form-elements/dealer-search-box/index.jsx